//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

// custom pages
import Logo from "assets/img/consent-logo.png";
import ContentImage from "assets/img/21DS1776-Thrive Current Vs Future.jpg";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import Congratulations from "assets/img/Congradulations.png";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";


// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
// material-ui icons

const ReviewTextField = withStyles({
  root: {
    width: "30%",
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#1473e6",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1473e6",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 5,
        padding: "12px 16px !important",
        fontSize: "14px !important",
        lineHeight: "22px",
        color: "#0f1d40",
      },
    },
  },
})(TextField);

export default function TransferAdminConsent() {
  const { getAdminConsentStatus, verifyAdminConsent } = auth();
  const classes = consentStyles();
  const location = useLocation();
  const history = useHistory();

  const param = new URLSearchParams(location.search);
  const token = param.get("token");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [data, setData] = useState({});
  const [loginToken, setLoginToken] = useState("");
  const [usLink, setusLink] = useState("");

  useEffect(() => {
    handleGetAdminConsentStatus();
  }, []);

  const handleGetAdminConsentStatus = async () => {
    try {
      setLoading(true);
      let res = await getAdminConsentStatus(token);
      if (res && res?.type == "success") {
        setStatus(res?.status);
        setMessage(res?.message);
        setusLink(res?.usLink)
        setLoading(false);
        setData(res);
        setLoginToken(res?.token);
        return;
      }
      if (res && res?.message) {
        setMessage(res?.message);
      } else {
        setMessage("Unauthorized");
      }
      setStatus("Unauthorized");
      setLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  const handleAdminConsent = async () => {
    try {
      let login = location.state && location.state.login;
      let values = {
        loyalty_id: data?.loyalty_id,
        customer_billto_account_number: data?.customer_billto_account_number,
        user: data?.user,
        DATABASE: data?.db
      };
      if (login) {
        values = {
          ...values,
          token,
        };
      }
      let res = await verifyAdminConsent(values);

      if (res && res?.type == "success") {
        setMessage(res?.message);
        setStatus("Processed");
        setLoginToken(res?.token);
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleClose = async () => {
    try {
      window.close();
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <div className={classes.mainDiv}>
      <img src={Logo} alt="logo" style={{ marginTop: 50, marginBottom: 50 }} />
      <Loader Loading={loading}>
        {status === "Inprocessed" && (
          <Card className={classes.card}>
            <div className={classes.divText}>Acknowledgement</div>
            <div className={classes.divSubText}>
              Thrive Rewards is a discount program intended for private dental
              practice and small group practices. For questions regarding
              eligibility, please contact Thrive Rewards Customer Service at
              1-800-888-6684. By enrolling in Henry Schein Thrive Rewards, you
              have read, understood and agree to the{" "}
              <a
                target="_blank"
                href={usLink}
              >
                [Terms & Conditions]
              </a>{" "}
              of this program and acknowledge that your points will be
              transferred from Connection Awards to Thrive Rewards at the
              standard point value. For an overview of the Henry Schein Thrive
              Rewards program rules, point value, and benefits{" "}
              <a
                target="_blank"
                href={usLink}
              >
                click here.
              </a>
            </div>
            <div className={classes.divSubText}>
              <Grid container spacing={2}>
                <Grid xs={6}>
                  {" "}
                  Member ID: <br />
                  {data?.loyalty_id}
                </Grid>
                <Grid xs={6} style={{ textAlign: "right" }}>
                  Billing Account: <br />
                  {data?.customer_billto_account_number}
                </Grid>
              </Grid>
            </div>
            <Button
              className={classes.cancelBtn}
              onClick={() => {
                handleClose();
              }}
            >
              Cancel Transfer
            </Button>
            <Button
              className={classes.enrollBtn}
              onClick={() => {
                handleAdminConsent();
              }}
            >
              Confirm Transfer
            </Button>
          </Card>
        )}
        {status === "Processed" && (
          <div>
            <img src={Congratulations} alt="" width="50%" />
            <div className={classes.message}>{message}</div>
            {location.state && location.state.login && loginToken && (
              <div>
                <Button
                  className={classes.viewMyDashboardBtn}
                  onClick={() => {
                    let redirectionUrl = `/dashboard/mydashboard?token=${loginToken}`;
                    window.location.replace(redirectionUrl);
                  }}
                >
                  View my dashboard
                </Button>
              </div>
            )}
          </div>
        )}
        {status === "Unauthorized" && (
          <div>
            <div className={classes.message}>{message}</div>
          </div>
        )}
      </Loader>
      {status === "Inprocessed" && (
        <img
          src={ContentImage}
          alt="consent-img"
          style={{ marginBottom: 20 }}
          width="75%"
        />
      )}
    </div>
  );
}
